import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import {
  ArrowUDownLeftIcon,
  CopyIcon,
  DotsThreeCircleVerticalIcon,
  PencilSimpleIcon,
  TrashIcon,
} from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ButtonMenu, Chip, IconButton, Text } from '@reveni-io/reveni-ui'

import { packagingTypeIcons } from '@/common/constants'

import { iconByLocationType, locationLabels } from '../constants'
import { getDefaultPackaging } from './helpers'
import * as Styles from './styles'

const Location = ({ info, packaging, onEdit, onDuplicate, onDelete, isDeleteDisabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const Icon = iconByLocationType[info?.type]
  const defaultPackaging = getDefaultPackaging(packaging, info?.default_packaging_id)

  const getDeliveryMethodsCountLabel = () => {
    const deliveryMethodsLength = info?.delivery_method_ids?.length

    if (deliveryMethodsLength === 1) {
      return `${deliveryMethodsLength} ${t('método de devolución')}`
    }

    return `${deliveryMethodsLength} ${t('métodos de devolución')}`
  }

  const getShippingMethodsCountLabel = () => {
    const shippingMethodsLength = info?.shipping_method_ids?.length

    if (shippingMethodsLength === 1) {
      return `${shippingMethodsLength} ${t('método de envío')}`
    }

    return `${shippingMethodsLength} ${t('métodos de envío')}`
  }

  return (
    <Styles.MainContainer onClick={() => onEdit(info)}>
      <Styles.InternalIdContainer>
        <Text type="bodyMBold" color={theme.colors.text.subtle}>
          #{info?.internal_id}
        </Text>
      </Styles.InternalIdContainer>
      <Styles.InfoContainer>
        <Styles.HeaderContainer>
          <Styles.TitleContainer>
            <Tooltip title={locationLabels[info?.type]}>
              <Icon size={24} />
            </Tooltip>
            <Text type="titleS">{info?.internal_name} |</Text> <Text type="bodyMRegular">{info?.public_name}</Text>
          </Styles.TitleContainer>
          <ButtonMenu
            stopPropagation
            menuItems={[
              {
                label: (
                  <Styles.ActionLabel>
                    <PencilSimpleIcon />
                    {t('Editar')}
                  </Styles.ActionLabel>
                ),
                onClick: () => onEdit(info),
              },
              {
                label: (
                  <Styles.ActionLabel>
                    <CopyIcon />
                    {t('Duplicar')}
                  </Styles.ActionLabel>
                ),
                onClick: () => onDuplicate(info),
              },
              {
                label: (
                  <Styles.ActionLabel>
                    <TrashIcon />
                    {t('Eliminar')}
                  </Styles.ActionLabel>
                ),
                disabled: isDeleteDisabled,
                onClick: () => onDelete(info),
              },
            ]}
            renderButton={onClick => (
              <IconButton
                variant="text"
                onClick={onClick}
                icon={<DotsThreeCircleVerticalIcon size={24} weight="light" />}
              />
            )}
          />
        </Styles.HeaderContainer>
        <Styles.TagsContainer>
          {info?.shipping_method_ids?.length > 0 && (
            <Chip Icon={ArrowUDownLeftIcon} label={getShippingMethodsCountLabel()} />
          )}
          {info?.delivery_method_ids?.length > 0 && (
            <Chip Icon={ArrowUDownLeftIcon} label={getDeliveryMethodsCountLabel()} />
          )}
          {defaultPackaging && <Chip Icon={packagingTypeIcons[defaultPackaging.type]} label={defaultPackaging.name} />}
        </Styles.TagsContainer>
        <div>
          <Text type="bodyMRegular">
            {info?.address?.line_1} {info?.address?.line_2} {info?.address?.house_number}
          </Text>
          <Text type="bodyMRegular">
            {info?.address?.postcode} {info?.address?.locality} {info?.address?.province?.name}
          </Text>
          <Text type="bodyMRegular">{info?.address?.country?.name}</Text>
        </div>
      </Styles.InfoContainer>
    </Styles.MainContainer>
  )
}

export default Location
